import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { createStructuredSelector } from 'reselect'
import styled from 'styled-components'
import get from 'lodash/get'
import moment from '../../../lib/moment.js'

import { Button } from 'reactstrap'
import { authSelector, standardPriceSelector, employeeLevelsSelector } from './../../../selectors'
import { standardPriceAction } from './../../../actions/'
import StandardPriceForm from '../../../components/standard-price'
import CustomModalMessage from '../../../components/modal-message'

class EditStandardPrice extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      level_code: '',
      level_name: '',
      cost: 0,
      price: 0,
      start_date: '',
      is_active: false,
      edit: false,
      id: '',
      level: [],
      activeTab: '1',
    }
    this.handleInput = this.handleInput.bind(this)
    this.submitForm = this.submitForm.bind(this)
    this.handleClickEdit = this.handleClickEdit.bind(this)
    this.handleDiscard = this.handleDiscard.bind(this)
    this.handleDelete = this.handleDelete.bind(this)
  }
  componentDidMount() {
    if (get(this.props, 'edit.edit')) {
      this.props.getStandardPrice(get(this.props, 'edit.id'), localStorage.getItem('access_token'))
    }
  }
  componentWillReceiveProps(nextProps) {
    if (get(nextProps, 'standardPriceGet')) {
      this.findLevel(get(nextProps, 'standardPriceGet'))
      this.props.resetGetStandardPrice()
    }
    if (get(nextProps, 'levelData')) {
      this.setState({ level: get(nextProps, 'levelData') })
    }
    if (get(nextProps, 'edit')) {
      if (get(nextProps, 'edit.edit')) {
        this.setState({ id: get(nextProps, 'edit.id'), edit: false })
        this.props.handleClickEdit(false, '')
        this.props.getStandardPrice(get(nextProps, 'edit.id'), localStorage.getItem('access_token'))
        this.props.resetGetStandardPrice()
      }
      this.setState({ edit: false })
    }
  }
  findLevel(standardPrice) {
    const standard = standardPrice
    const temp = []
    const levels = this.state.level

    for (let i = 0; i < levels.length; i++) {
      if (levels[i]._id === standard.emp_level_id) {
        this.setState({
          id: standard._id,
          level_code: levels[i].level_code,
          level_name: levels[i].name,
          cost: standard.cost,
          price: standard.price,
          start_date: standard.start_date ? moment(standard.start_date).format('YYYY-MM-DD') : '',
          is_active: standard.is_active,
        })
      }
    }
    this.setState({ data: temp, isOK: true })
  }
  handleInput(e) {
    this.setState({ [e.target.name]: e.target.value })
  }
  handleClickEdit() {
    this.setState({ edit: true })
  }
  handleDiscard() {
    this.props.cancelDiscard()
    this.props.handleSpan(false)
  }
  handleDelete() {
    this.deactivateStandardPrice()
    this.props.cancelDelete()
    this.props.handleSpan(false)
  }
  deactivateStandardPrice() {
    this.props.deactivateStandardPrice(get(this.state, 'id'), localStorage.getItem('access_token'))
  }
  submitForm() {
    if (get(this.state, 'edit')) {
      this.props.editStandardPrice(
        get(this.state, 'id'),
        {
          cost: this.state.cost,
          price: this.state.price,
          start_date: new moment(this.state.start_date),
          is_active: this.state.is_active,
        },
        localStorage.getItem('access_token'))
    }
  }
  render() {
    const button = (
      <div>
        <NewButton outline color="danger" onClick={ () => this.props.showDelete('confirmDelete') }>Delete</NewButton>
        <NewButton color="success" onClick={ this.state.edit ? this.submitForm : this.handleClickEdit }>{ this.state.edit ? 'Save' : 'Edit' }</NewButton>
      </div>
    )
    const buttonDelete = (
      <div>
        <NewButton color="" onClick={ this.props.cancelDelete }>Cancel</NewButton>
        <NewButton color="danger" onClick={ this.handleDelete }>Delete</NewButton>
      </div>
    )
    const buttonDiscard = (
      <div>
        <NewButton color="" onClick={ this.props.cancelDiscard }>Cancel</NewButton>
        <NewButton color="danger" onClick={ this.handleDiscard }>Discard</NewButton>
      </div>
    )
    return (
    /* eslint no-underscore-dangle: 0 */
      <div>
        <CustomModalMessage
          hide={ this.props.cancelDelete }
          show={ get(this.props, 'confirmType') === 'confirmDelete' }
          type={ get(this.props, 'confirmStatus') }
          message={ get(this.props, 'confirmMessage') }
          button={ buttonDelete }
        />
        <CustomModalMessage
          hide={ this.props.cancelDiscard }
          show={ get(this.props, 'confirmType') === 'confirmDiscard' }
          type={ get(this.props, 'confirmStatus') }
          message={ get(this.props, 'confirmMessage') }
          button={ buttonDiscard }
        />
        <StandardPriceForm
          edit={ this.state.edit }
          submitForm={ this.submitForm }
          handleClickEdit={ this.handleClickEdit }
          handleSpan={ this.props.handleSpan }
          level_code={ this.state.level_code }
          level_name={ this.state.level_name }
          cost={ this.state.cost }
          price={ this.state.price }
          start_date={ this.state.start_date }
          is_active={ this.state.is_active }
          handleInput={ this.handleInput }
          button={ button }
          confrim={ get(this.props, 'confirm') }
          cancelForm={ this.props.cancelForm }
          showDiscard={ this.state.edit ? this.props.showDiscard : () => this.props.handleSpan(false) }
        />
      </div>
    )
  }
}

EditStandardPrice.propTypes = {
  editStandardPrice: PropTypes.func.isRequired,
  getStandardPrice: PropTypes.func.isRequired,
  handleClickEdit: PropTypes.func.isRequired,
  handleSpan: PropTypes.func.isRequired,
  resetGetStandardPrice: PropTypes.func.isRequired,
  cancelDelete: PropTypes.func.isRequired,
  showDelete: PropTypes.func.isRequired,
  cancelDiscard: PropTypes.func.isRequired,
  cancelForm: PropTypes.func.isRequired,
  showDiscard: PropTypes.func.isRequired,
}
const mapStateToProps = (state, props) => createStructuredSelector({
  authData: authSelector.getUserData,
  standardPriceGet: standardPriceSelector.getGetStandardPriceData,
  levelData: employeeLevelsSelector.getListEmployeeLevels,
})(state, props)
const mapDispatchToProps = dispatch => bindActionCreators({
  getStandardPrice: standardPriceAction.getStandardPriceByID,
  resetGetStandardPrice: standardPriceAction.resetGetStandardPrice,
  editStandardPrice: standardPriceAction.editStandardPrice,
  deactivateStandardPrice: standardPriceAction.deactivateStandardPrice,
}, dispatch)

export default connect(mapStateToProps, mapDispatchToProps)(EditStandardPrice)

const NewButton = styled(Button)`
  width: 150px;
  height: 50px;
  margin: 10px;
`



// WEBPACK FOOTER //
// ./src/pages/standard-price/edit/index.js